import { render, staticRenderFns } from "./LocationPlatformFees.vue?vue&type=template&id=9befacee&"
import script from "./LocationPlatformFees.vue?vue&type=script&lang=js&"
export * from "./LocationPlatformFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports